module.exports = __webpack_public_path__ + "img\\Ebanner00.615fb8c1.jpg";